import { ServicioV3DTO } from "../servicioV3.dto";
import { BaseResponseDTO } from "./base.response.dto";

export class GetListaServiciosV3ResponseDTO extends BaseResponseDTO {

    success: boolean;
    msg: string;
    data: {
      hasNext: boolean;
      hasPrev: boolean;
      pageIndex: number;
      pageSize: number;
      totalPageCount: number;
      totalRowCount: number;
      list: Array<ServicioV3DTO>;
    }
  
  }
  